// RootComponent.tsx
import React, { useEffect } from 'react';
import {  Route, Routes, Navigate, useLocation } from 'react-router-dom';
import About from './pages/About';
import NotFoundPage from './pages/NotFoundPage';
import './styles/main.sass';
import Header from 'src/components/navigations/Header';
import Footer from 'src/components/navigations/Footer';
import Login from './features/access/login/Login';
import SignUp from './features/access/signup/SignUp';
import News from './features/xnews/News';
import { useAppDispatch } from 'src/store/reducers/store';
import { login } from 'src/store/reducers/authSlice';
import NewsList from 'src/features/xnews/NewsList';
import NewsDetail from 'src/features/xnews/NewsDetail';
import Test from './pages/Test';
import { useHreflangTags } from './components/seo/hreflang';
// import { normalizeLocale } from './components/utils/localeUtils';
import { TranslationProvider, useTranslations } from './contexts/TranslationContext';
import { getCurrentLanguageFromCookies } from './utils/navigationApi';
import Archive from 'src/features/xnews/Archive';
// import ArchiveDate from 'src/features/xnews/ArchiveDate'; // Module not found
import ArchiveSubtype from 'src/features/xnews/ArchiveSubtype';
import ArchiveDate from './features/xnews/ArchiveDate';
import Contact from './features/contact/Contact';
import Privacy from './features/privacy/Privacy';
import Terms from './features/terms/Terms';
// Import the categories from the shared JSON file with proper typing
import categoriesData from './backendshared/xnews_categories.json';

// Type definition for the categories object
interface Categories {
    main: string[];
    [key: string]: string[]; // All other category properties are string arrays
}

// Add type assertion to make TypeScript happy
const categories = categoriesData as Categories;

// Component for handling external redirects
interface ExternalRedirectProps {
  to: string;
}

const ExternalRedirect: React.FC<ExternalRedirectProps> = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);

  return <div>Redirecting to sitemap XML...</div>;
};

const RoutesWithTranslations: React.FC = (props) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { language, forceReload } = useTranslations();
    const { updateHreflangTags } = useHreflangTags(language);

    // Force reload translations on initial mount
    useEffect(() => {
        console.log('[RootComponent] Reloading translations on app start');
        forceReload().catch(error => {
            console.error('[RootComponent] Error reloading translations:', error);
        });
        // We only want to run this once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateHreflangTags();
    }, [location, language, updateHreflangTags]);

    const handleLogin = (userData: { email: string; name: string }) => {
        console.log('root dispatch login userData', userData);
        dispatch(login(userData));
    };

    // Handler for locale changes - not needed since we use TranslationContext
    const handleLocaleChange = (newLocale: string) => {
        console.log(`[RootComponent] Locale change handler called with: ${newLocale}`);
        // Implementation handled by TranslationContext
    };

    // Get subcategories from the imported JSON
    const trendingSubcategories = categories.trending;
    const entertainmentSubcategories = categories.entertainment;
    const sportsSubcategories = categories.sports;
    const worldSubcategories = categories.world;
    const politicsSubcategories = categories.politics;
    const businessSubcategories = categories.business;
    const technologySubcategories = categories.technology;
    const healthSubcategories = categories.health;
    const lifestyleSubcategories = categories.lifestyle;

    console.log('categories', entertainmentSubcategories);

    return (

        
        <div className="min-h-screen bg-white text-black">
            <Header setLocale={handleLocaleChange} />

            
            <Routes>
                <Route path="*" element={<NotFoundPage />} />
                <Route path="/" element={<LanguageBasedRedirect />} />
                <Route path="/home" element={<LanguageBasedRedirect />} />
                
               

                <Route path="/en" element={<Navigate to="/en/trending" replace />} />
                <Route path="/cn" element={<Navigate to="/cn/trending" replace />} />
                <Route path="/tw" element={<Navigate to="/tw/trending" replace />} />
                <Route path="/es" element={<Navigate to="/es/trending" replace />} />
                <Route path="/fr" element={<Navigate to="/fr/trending" replace />} />


                {/* <Route path="/en/home" element={<HomePage lang="en" />} /> */}
                <Route path="/en/home" element={<Navigate to="/en/trending" replace />} />
                <Route path="/cn/home" element={<Navigate to="/cn/trending" replace />} />
                <Route path="/tw/home" element={<Navigate to="/tw/trending" replace />} />
                <Route path="/es/home" element={<Navigate to="/es/trending" replace />} />
                <Route path="/fr/home" element={<Navigate to="/fr/trending" replace />} />

                <Route path="/en/about" element={<About lang="en" />} />
                <Route path="/cn/about" element={<About lang="cn" />} />
                <Route path="/tw/about" element={<About lang="tw" />} />
                <Route path="/es/about" element={<About lang="es" />} />
                <Route path="/fr/about" element={<About lang="fr" />} />

                {/* Contact routes */}
                <Route path="/en/contact" element={<Contact lang="en" />} />
                <Route path="/cn/contact" element={<Contact lang="cn" />} />
                <Route path="/tw/contact" element={<Contact lang="tw" />} />
                <Route path="/es/contact" element={<Contact lang="es" />} />
                <Route path="/fr/contact" element={<Contact lang="fr" />} />

                {/* Privacy routes */}
                <Route path="/en/privacy" element={<Privacy lang="en" />} />
                <Route path="/cn/privacy" element={<Privacy lang="cn" />} />
                <Route path="/tw/privacy" element={<Privacy lang="tw" />} />
                <Route path="/es/privacy" element={<Privacy lang="es" />} />
                <Route path="/fr/privacy" element={<Privacy lang="fr" />} />

                {/* Terms routes */}
                <Route path="/en/terms" element={<Terms lang="en" />} />
                <Route path="/cn/terms" element={<Terms lang="cn" />} />
                <Route path="/tw/terms" element={<Terms lang="tw" />} />
                <Route path="/es/terms" element={<Terms lang="es" />} />
                <Route path="/fr/terms" element={<Terms lang="fr" />} />

                <Route path="/test" element={<Test lang="tw" />} />

                <Route path="/en/login" element={<Login onLogin={handleLogin} lang="en" />} />
                <Route path="/cn/login" element={<Login onLogin={handleLogin} lang="cn" />} />
                <Route path="/tw/login" element={<Login onLogin={handleLogin} lang="tw" />} />
                <Route path="/es/login" element={<Login onLogin={handleLogin} lang="es" />} />
                <Route path="/fr/login" element={<Login onLogin={handleLogin} lang="fr" />} />

                <Route path="/en/signup" element={<SignUp onLogin={handleLogin} lang="en" />} />
                <Route path="/cn/signup" element={<SignUp onLogin={handleLogin} lang="cn"/>} />
                <Route path="/tw/signup" element={<SignUp onLogin={handleLogin} lang="tw" />} />
                <Route path="/es/signup" element={<SignUp onLogin={handleLogin} lang="es" />} />
                <Route path="/fr/signup" element={<SignUp onLogin={handleLogin} lang="fr" />} />

                {/* <Route path="/en/trending" element={<News {...props} lang="en" />} />
                <Route path="/cn/trending" element={<News {...props} lang="cn" />} />
                <Route path="/tw/trending" element={<News {...props} lang="tw" />} />
                <Route path="/es/trending" element={<News {...props} lang="es" />} />
                <Route path="/fr/trending" element={<News {...props} lang="fr" />} /> */}

                <Route path="/en/trending" element={<News {...props} lang="en" />} />
                <Route path="/cn/trending" element={<News {...props} lang="cn" />} />
                <Route path="/tw/trending" element={<News {...props} lang="tw" />} />
                <Route path="/es/trending" element={<News {...props} lang="es" />} />
                <Route path="/fr/trending" element={<News {...props} lang="fr" />} />

                <Route path="/en/newslist" element={<NewsList type="trending" />} />
                <Route path="/cn/newslist" element={<NewsList type="trending" />} />
                <Route path="/tw/newslist" element={<NewsList type="trending" />} />
                <Route path="/es/newslist" element={<NewsList type="trending" />} />
                <Route path="/fr/newslist" element={<NewsList type="trending" />} />

                {/* <Route path="/en/trendingnews/:id" element={<NewsDetail lang="en" />} />
                <Route path="/cn/trendingnews/:id" element={<NewsDetail lang="cn" />} />
                <Route path="/tw/trendingnews/:id" element={<NewsDetail lang="tw" />} />
                <Route path="/es/trendingnews/:id" element={<NewsDetail lang="es" />} />
                <Route path="/fr/trendingnews/:id" element={<NewsDetail lang="fr" />} /> */}

                <Route path="/:lang/trendingnews/:id" element={<NewsDetail />} />

                {/* Archive Routes */}
                <Route path="/en/archive" element={<Archive lang="en" />} />
                <Route path="/cn/archive" element={<Archive lang="cn" />} />
                <Route path="/tw/archive" element={<Archive lang="tw" />} />
                <Route path="/es/archive" element={<Archive lang="es" />} />
                <Route path="/fr/archive" element={<Archive lang="fr" />} />

                {/* Archive Date Routes - With and without type parameter */}
                <Route path="/en/archive/dates" element={<ArchiveDate lang="en" />} />
                <Route path="/cn/archive/dates" element={<ArchiveDate lang="cn" />} />
                <Route path="/tw/archive/dates" element={<ArchiveDate lang="tw" />} />
                <Route path="/es/archive/dates" element={<ArchiveDate lang="es" />} />
                <Route path="/fr/archive/dates" element={<ArchiveDate lang="fr" />} />

                <Route path="/en/archive/:type/dates" element={<ArchiveDate lang="en" />} />
                <Route path="/cn/archive/:type/dates" element={<ArchiveDate lang="cn" />} />
                <Route path="/tw/archive/:type/dates" element={<ArchiveDate lang="tw" />} />
                <Route path="/es/archive/:type/dates" element={<ArchiveDate lang="es" />} />
                <Route path="/fr/archive/:type/dates" element={<ArchiveDate lang="fr" />} />

                {/* Archive Subtype (News List) Routes */}
                <Route path="/en/archive/dates/:date" element={<ArchiveSubtype lang="en" />} />
                <Route path="/cn/archive/dates/:date" element={<ArchiveSubtype lang="cn" />} />
                <Route path="/tw/archive/dates/:date" element={<ArchiveSubtype lang="tw" />} />
                <Route path="/es/archive/dates/:date" element={<ArchiveSubtype lang="es" />} />
                <Route path="/fr/archive/dates/:date" element={<ArchiveSubtype lang="fr" />} />

                {/* News subcategory routes */}
                {trendingSubcategories.map(subtype => (
                    <React.Fragment key={subtype}>
                        <Route 
                            path={`/en/trending/${subtype}`} 
                            element={<News lang="en" type="trending" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/cn/trending/${subtype}`} 
                            element={<News lang="cn" type="trending" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/tw/trending/${subtype}`} 
                            element={<News lang="tw" type="trending" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/es/trending/${subtype}`} 
                            element={<News lang="es" type="trending" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/fr/trending/${subtype}`} 
                            element={<News lang="fr" type="trending" subtype={subtype} />} 
                        />
                    </React.Fragment>
                ))}

                {/* Entertainment subcategory routes */}
                {entertainmentSubcategories.map(subtype => (
                    <React.Fragment key={subtype}>
                        <Route 
                            path={`/en/entertainment/${subtype}`} 
                            element={<News lang="en" type="entertainment" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/cn/entertainment/${subtype}`} 
                            element={<News lang="cn" type="entertainment" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/tw/entertainment/${subtype}`} 
                            element={<News lang="tw" type="entertainment" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/es/entertainment/${subtype}`} 
                            element={<News lang="es" type="entertainment" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/fr/entertainment/${subtype}`} 
                            element={<News lang="fr" type="entertainment" subtype={subtype} />} 
                        />
                    </React.Fragment>
                ))}

                {/* Main entertainment routes */}
                <Route path="/en/entertainment" element={<News lang="en" type="entertainment" />} />
                <Route path="/cn/entertainment" element={<News lang="cn" type="entertainment" />} />
                <Route path="/tw/entertainment" element={<News lang="tw" type="entertainment" />} />
                <Route path="/es/entertainment" element={<News lang="es" type="entertainment" />} />
                <Route path="/fr/entertainment" element={<News lang="fr" type="entertainment" />} />

                {/* Sports subcategory routes */}
                {sportsSubcategories.map(subtype => (
                    <React.Fragment key={subtype}>
                        <Route 
                            path={`/en/sports/${subtype}`} 
                            element={<News lang="en" type="sports" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/cn/sports/${subtype}`} 
                            element={<News lang="cn" type="sports" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/tw/sports/${subtype}`} 
                            element={<News lang="tw" type="sports" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/es/sports/${subtype}`} 
                            element={<News lang="es" type="sports" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/fr/sports/${subtype}`} 
                            element={<News lang="fr" type="sports" subtype={subtype} />} 
                        />
                    </React.Fragment>
                ))}

                {/* Main sports routes */}
                <Route path="/en/sports" element={<News lang="en" type="sports" />} />
                <Route path="/cn/sports" element={<News lang="cn" type="sports" />} />
                <Route path="/tw/sports" element={<News lang="tw" type="sports" />} />
                <Route path="/es/sports" element={<News lang="es" type="sports" />} />
                <Route path="/fr/sports" element={<News lang="fr" type="sports" />} />

                {/* Main world routes */}
                <Route path="/en/world" element={<News lang="en" type="world" />} />
                <Route path="/cn/world" element={<News lang="cn" type="world" />} />
                <Route path="/tw/world" element={<News lang="tw" type="world" />} />
                <Route path="/es/world" element={<News lang="es" type="world" />} />
                <Route path="/fr/world" element={<News lang="fr" type="world" />} />

                {/* Main politics routes */}
                <Route path="/en/politics" element={<News lang="en" type="politics" />} />
                <Route path="/cn/politics" element={<News lang="cn" type="politics" />} />
                <Route path="/tw/politics" element={<News lang="tw" type="politics" />} />
                <Route path="/es/politics" element={<News lang="es" type="politics" />} />
                <Route path="/fr/politics" element={<News lang="fr" type="politics" />} />

                {/* Main business routes */}
                <Route path="/en/business" element={<News lang="en" type="business" />} />
                <Route path="/cn/business" element={<News lang="cn" type="business" />} />
                <Route path="/tw/business" element={<News lang="tw" type="business" />} />
                <Route path="/es/business" element={<News lang="es" type="business" />} />
                <Route path="/fr/business" element={<News lang="fr" type="business" />} />

                {/* Main technology routes */}
                <Route path="/en/technology" element={<News lang="en" type="technology" />} />
                <Route path="/cn/technology" element={<News lang="cn" type="technology" />} />
                <Route path="/tw/technology" element={<News lang="tw" type="technology" />} />
                <Route path="/es/technology" element={<News lang="es" type="technology" />} />
                <Route path="/fr/technology" element={<News lang="fr" type="technology" />} />

                {/* Main health routes */}
                <Route path="/en/health" element={<News lang="en" type="health" />} />
                <Route path="/cn/health" element={<News lang="cn" type="health" />} />
                <Route path="/tw/health" element={<News lang="tw" type="health" />} />
                <Route path="/es/health" element={<News lang="es" type="health" />} />
                <Route path="/fr/health" element={<News lang="fr" type="health" />} />

                {/* Main lifestyle routes */}
                <Route path="/en/lifestyle" element={<News lang="en" type="lifestyle" />} />
                <Route path="/cn/lifestyle" element={<News lang="cn" type="lifestyle" />} />
                <Route path="/tw/lifestyle" element={<News lang="tw" type="lifestyle" />} />
                <Route path="/es/lifestyle" element={<News lang="es" type="lifestyle" />} />
                <Route path="/fr/lifestyle" element={<News lang="fr" type="lifestyle" />} />

                {/* World subcategory routes */}
                {worldSubcategories.map(subtype => (
                    <React.Fragment key={subtype}>
                        <Route 
                            path={`/en/world/${subtype}`} 
                            element={<News lang="en" type="world" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/cn/world/${subtype}`} 
                            element={<News lang="cn" type="world" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/tw/world/${subtype}`} 
                            element={<News lang="tw" type="world" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/es/world/${subtype}`} 
                            element={<News lang="es" type="world" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/fr/world/${subtype}`} 
                            element={<News lang="fr" type="world" subtype={subtype} />} 
                        />
                    </React.Fragment>
                ))}

                {/* Politics subcategory routes */}
                {politicsSubcategories.map(subtype => (
                    <React.Fragment key={subtype}>
                        <Route 
                            path={`/en/politics/${subtype}`} 
                            element={<News lang="en" type="politics" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/cn/politics/${subtype}`} 
                            element={<News lang="cn" type="politics" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/tw/politics/${subtype}`} 
                            element={<News lang="tw" type="politics" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/es/politics/${subtype}`} 
                            element={<News lang="es" type="politics" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/fr/politics/${subtype}`} 
                            element={<News lang="fr" type="politics" subtype={subtype} />} 
                        />
                    </React.Fragment>
                ))}

                {/* Business subcategory routes */}
                {businessSubcategories.map(subtype => (
                    <React.Fragment key={subtype}>
                        <Route 
                            path={`/en/business/${subtype}`} 
                            element={<News lang="en" type="business" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/cn/business/${subtype}`} 
                            element={<News lang="cn" type="business" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/tw/business/${subtype}`} 
                            element={<News lang="tw" type="business" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/es/business/${subtype}`} 
                            element={<News lang="es" type="business" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/fr/business/${subtype}`} 
                            element={<News lang="fr" type="business" subtype={subtype} />} 
                        />
                    </React.Fragment>
                ))}

                {/* Technology subcategory routes */}
                {technologySubcategories.map(subtype => (
                    <React.Fragment key={subtype}>
                        <Route 
                            path={`/en/technology/${subtype}`} 
                            element={<News lang="en" type="technology" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/cn/technology/${subtype}`} 
                            element={<News lang="cn" type="technology" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/tw/technology/${subtype}`} 
                            element={<News lang="tw" type="technology" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/es/technology/${subtype}`} 
                            element={<News lang="es" type="technology" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/fr/technology/${subtype}`} 
                            element={<News lang="fr" type="technology" subtype={subtype} />} 
                        />
                    </React.Fragment>
                ))}

                {/* Health subcategory routes */}
                {healthSubcategories.map(subtype => (
                    <React.Fragment key={subtype}>
                        <Route 
                            path={`/en/health/${subtype}`} 
                            element={<News lang="en" type="health" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/cn/health/${subtype}`} 
                            element={<News lang="cn" type="health" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/tw/health/${subtype}`} 
                            element={<News lang="tw" type="health" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/es/health/${subtype}`} 
                            element={<News lang="es" type="health" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/fr/health/${subtype}`} 
                            element={<News lang="fr" type="health" subtype={subtype} />} 
                        />
                    </React.Fragment>
                ))}

                {/* Lifestyle subcategory routes */}
                {lifestyleSubcategories.map(subtype => (
                    <React.Fragment key={subtype}>
                        <Route 
                            path={`/en/lifestyle/${subtype}`} 
                            element={<News lang="en" type="lifestyle" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/cn/lifestyle/${subtype}`} 
                            element={<News lang="cn" type="lifestyle" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/tw/lifestyle/${subtype}`} 
                            element={<News lang="tw" type="lifestyle" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/es/lifestyle/${subtype}`} 
                            element={<News lang="es" type="lifestyle" subtype={subtype} />} 
                        />
                        <Route 
                            path={`/fr/lifestyle/${subtype}`} 
                            element={<News lang="fr" type="lifestyle" subtype={subtype} />} 
                        />
                    </React.Fragment>
                ))}
            </Routes>
         
            <Footer />
        </div>
    );
};

// Memoized App component to reduce unnecessary re-renders
const MemoizedRoutesWithTranslations = React.memo(RoutesWithTranslations);

const RootComponent: React.FC = () => {
    return (
        <TranslationProvider>
            <MemoizedRoutesWithTranslations />
        </TranslationProvider>
    );
};

// Inline component for language-based redirection
const LanguageBasedRedirect: React.FC = () => {
    // Get language from cookies or browser default
    const cookieLanguage = getCurrentLanguageFromCookies();
    const browserLanguage = navigator.language || 'en';
    
    // Normalize language code
    let language = cookieLanguage;
    console.log("browserLanguage: "+language);
    if (!language) {
        // If no cookie, use browser language
        if (browserLanguage.startsWith('zh')) {
            if (browserLanguage.toLowerCase().includes('cn')) {
                // language = 'zh-CN';
                language = 'cn';
            } else {
                // language = 'zh-TW';
                language = 'tw';
            }
        } else if (browserLanguage.startsWith('es')) {
            language = 'es';
        } else if (browserLanguage.startsWith('fr')) {
            language = 'fr';
        } else {
            language = 'en';
        }
    }
    
    // Get URL prefix
    // let urlPrefix = '/en';
    // if (language === 'zh-CN') urlPrefix = '/cn';
    // else if (language === 'zh-TW') urlPrefix = '/tw';
    // else if (language === 'es') urlPrefix = '/es';
    // else if (language === 'fr') urlPrefix = '/fr';

    const urlPrefix = '/'+language;
    
    // Redirect to news page
    return <Navigate to={`${urlPrefix}/trending`} replace />;
};

export default RootComponent;